/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RemoveManualMembersForBillingGroupMutationInput = {
    addExclusions?: boolean | null | undefined;
    billingGroupId: string;
    clientMutationId?: string | null | undefined;
    orgRelayId: string;
    personIds: Array<string>;
};
export type RemoveManualMembersForBillingGroupMutationVariables = {
    input: RemoveManualMembersForBillingGroupMutationInput;
};
export type RemoveManualMembersForBillingGroupMutationResponse = {
    readonly removeManualMembersForBillingGroup: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RemoveManualMembersForBillingGroupMutation = {
    readonly response: RemoveManualMembersForBillingGroupMutationResponse;
    readonly variables: RemoveManualMembersForBillingGroupMutationVariables;
};



/*
mutation RemoveManualMembersForBillingGroupMutation(
  $input: RemoveManualMembersForBillingGroupMutationInput!
) {
  removeManualMembersForBillingGroup(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RemoveManualMembersForBillingGroupMutationPayload",
            "kind": "LinkedField",
            "name": "removeManualMembersForBillingGroup",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveManualMembersForBillingGroupMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveManualMembersForBillingGroupMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "e1a4062145c14052032eeb13ced6c26c",
            "id": null,
            "metadata": {},
            "name": "RemoveManualMembersForBillingGroupMutation",
            "operationKind": "mutation",
            "text": "mutation RemoveManualMembersForBillingGroupMutation(\n  $input: RemoveManualMembersForBillingGroupMutationInput!\n) {\n  removeManualMembersForBillingGroup(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '521d2d349592066aef3e4585a2c9931f';
export default node;
